
/**
 * querySelector
 *
 * @param {string} selector セレクタ
 * @param {object} context コンテキスト
 */
export const $ = (selector, context = document) => context.querySelector(selector);

/**
 * querySelectorAll
 *
 * @param {string} selector セレクタ
 * @param {object} context コンテキスト
 */
export const $$ = (selector, context = document) => context.querySelectorAll(selector);

/**
 * DOMかどうか
 *
 * @param {object} obj 判定したいオブジェクト
 */
export function isDOM(obj) {
    try {
        return obj instanceof Window
            || obj instanceof HTMLDocument
            || obj instanceof HTMLElement;
    } catch (e) {
        return typeof obj === 'object'
            && obj.nodeType === 1
            && typeof obj.style === 'object'
            && typeof obj.ownerDocument === 'object';
    }
}
